module.exports = __webpack_public_path__ + "roboto-lightitalic-webfont.60872969c3dd16b4fcc5.woff";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-KYC-Admin/src/assets/fonts/roboto-lightitalic-webfont.woff
// module id = ../../../../../src/assets/fonts/roboto-lightitalic-webfont.woff
// module chunks = styles